import { render, staticRenderFns } from "./acompanhar.vue?vue&type=template&id=61161622&scoped=true&"
import script from "./acompanhar.vue?vue&type=script&lang=js&"
export * from "./acompanhar.vue?vue&type=script&lang=js&"
import style0 from "./acompanhar.vue?vue&type=style&index=0&id=61161622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61161622",
  null
  
)

export default component.exports